import { queryOptions } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';
import { isApiError } from '@/utils';

export const directDebitQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.UK.directDebit,
    queryFn: API.UK.directDebit.getDirectDebit,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => (isApiError(error, { status: 404 }) || failureCount > 3 ? false : true),
  });
